export default __webpack_public_path__ + "static/media/launch-home.b539e3f9.png";